<template>
  <div class="form-group row">
    <label class="col-12">Número do diário: <span class="text-danger">*</span></label>
    <div class="col-sm-12">
      <div class="form-group input-group" :class="{
        'form-group--error': $v.eliminar.numeroDiario.$error
      }">
        <input type="text" class="form-control" v-model="$v.eliminar.numeroDiario.$model">
      </div>
      <div class="error" v-if="!$v.eliminar.numeroDiario.required">O campo é obrigatório</div>
    </div>
    <label class="col-12">Data de publicação do diário (Deve ser maior que 30 dias): <span class="text-danger">*</span></label>
    <div class="col-sm-12">
      <div class="form-group input-group" :class="{
        'form-group--error': $v.eliminar.dataPublicacaoDiario.$error
      }">
        <input type="date" class="form-control" v-model="$v.eliminar.dataPublicacaoDiario.$model">
      </div>
      <div class="error" v-if="!$v.eliminar.dataPublicacaoDiario.required">O campo é obrigatório</div>
      <div class="error" v-if="!$v.eliminar.dataPublicacaoDiario.lessThen30Days">A data de publicação do diário deve ser maior que 30 dias, contando a partir de hoje</div>
    </div>
    <label class="col-12">Número do edital: <span class="text-danger">*</span></label>
    <div class="col-sm-12">
      <div class="form-group input-group" :class="{
        'form-group--error': $v.eliminar.numeroEdital.$error
      }">
        <input type="text" class="form-control" v-model="$v.eliminar.numeroEdital.$model">
      </div>
      <div class="error" v-if="!$v.eliminar.numeroEdital.required">O campo é obrigatório</div>
    </div>
    <label class="col-12">Data do edital: <span class="text-danger">*</span></label>
    <div class="col-sm-12">
      <div class="form-group input-group" :class="{
        'form-group--error': $v.eliminar.dataEdital.$error
      }">
        <input type="date" class="form-control" v-model="$v.eliminar.dataEdital.$model">
      </div>
      <div class="error" v-if="!$v.eliminar.dataEdital.required">O campo é obrigatório</div>
    </div>

    <div class="col-12" v-if="progress.is" :key="progress.key">
      <hr>
      <div v-for="processo in $store.getters.getDataTableChecked" :key="getKey(processo.data.atributos.numeroProcesso)">
        <span>{{ formatarProtocolo(processo.data.atributos.numeroProcesso) }}</span>
        <span
          v-if="isVisibleTryAgainEliminar(processo.data.atributos.numeroProcesso)"
          class="badge badge-info link"
          @click="eliminarProtocolo(processo.data.atributos.numeroProcesso)"
        >
          <i class="fa fa-refresh" aria-hidden="true"></i> Eliminar novamente
        </span>
        <progress-bar
          :key="getKey(processo.data.atributos.numeroProcesso)"
          :percentage="getProgress(processo.data.atributos.numeroProcesso)"
          :danger="`bg-${getStatus(processo.data.atributos.numeroProcesso)}`"
          :warning="`bg-${getStatus(processo.data.atributos.numeroProcesso)}`"
          :success="`bg-${getStatus(processo.data.atributos.numeroProcesso)}`"
          :animated="true"
          class="mt-1 mb-3"
        />
      </div>
      <div class="col-12 text-right mb-2" v-if="progress.finished && processos.length !== progress.sucesso">
        <span class="badge badge-info text-left">Alguns protocolos não foram concluidos<br> Tente novamente os protocolos com erro</span>
      </div>
    </div>

    <div class="modal-body text-md-right text-sm-center">
      <button v-if="!progress.is" type="button" class="btn btn-outline-danger m-1" @click.prevent="() => {
        closeModalEvent()
      }">Cancelar</button>
      <button v-if="progress.is" type="button" class="btn btn-outline-danger m-1" @click.prevent="() => {
        closeModalEvent()
      }">Fechar</button>
      <button v-if="!progress.is" type="button" class="btn btn-outline-primary m-1" @click.prevent="persistirElminacao()">Prosseguir</button>
      <button v-if="progress.is" type="button" class="btn btn-outline-dark m-1">Prosseguir</button>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import VirtusService from '@/services/VirtusService'
import progressBar from '@/components/progressBar/ProgressBar'

import { protocoloParse } from '@/uteis/converters/ProtocoloConverter'

export default {
  name: 'eliminar',

  components: {
    progressBar
  },

  props: {
    closeModalEvent: { required: true, type: Function },
    protocolo: { required: false, type: String },
    atualizarConsulta: { required: true, type: Function },
    editarEliminacao: { required: false, type: Object }
  },

  data () {
    return {
      eliminar: {
        numeroDiario: '',
        dataPublicacaoDiario: '',
        numeroEdital: '',
        dataEdital: ''
      },
      progress: {
        isEliminar: false,
        is: false,
        background: false,
        finished: false,
        length: 0,
        sucesso: 0,
        key: false,
        alert: {
          type: 'light',
          texto: 'Eliminando os protocolos:'
        },
        processos: {}
      }
    }
  },

  validations: {
    eliminar: {
      numeroDiario: {
        required
      },
      dataPublicacaoDiario: {
        required,
        lessThen30Days (value) {
          if (value === '') {
            return false
          }

          const selectedDate = new Date(value)
          const now = new Date()

          const diffTime = Math.abs(selectedDate - now)
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

          if (diffDays > 30) {
            return true
          }

          return false
        }
      },
      numeroEdital: {
        required
      },
      dataEdital: {
        required
      }
    }
  },

  created () {
    this.service = new VirtusService()

    if (this.editarEliminacao) {
      this.$v.eliminar.numeroDiario.$model = this.editarEliminacao.dadosDiario.numeroDiario
      this.$v.eliminar.numeroEdital.$model = this.editarEliminacao.dadosDiario.numeroEdital

      const dataPublicacaoDiario = this.editarEliminacao.dadosDiario.dataPublicacaoDiario
      this.$v.eliminar.dataPublicacaoDiario.$model = dataPublicacaoDiario.slice(0, dataPublicacaoDiario.search('T'))

      const dataEdital = this.editarEliminacao.dadosDiario.dataEdital
      this.$v.eliminar.dataEdital.$model = dataEdital.slice(0, dataEdital.search('T'))
    }
  },

  destroyed () {
    this.closeModalEvent()
  },

  methods: {
    async persistirElminacao () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.progress = {
        ...this.progress,
        isEliminar: true,
        is: true,
        background: true,
        key: !this.progress.key,
        alert: {
          type: 'light',
          texto: 'Recebendo/Atribuindo os protocolos:'
        }
      }

      const dadosSessao = this.$store.getters.getDadosSessao.sessao

      if (this.editarEliminacao) {
        const eliminar = {
          ...this.eliminar,
          dataPublicacaoDiario: new Date(this.eliminar.dataPublicacaoDiario).getTime(),
          dataEdital: new Date(this.eliminar.dataEdital).getTime()
        }

        this.service.editarEliminacaoProtocolo({
          dadosDiario: eliminar,
          processo: this.protocolo
        }, dadosSessao).then((data) => {
          this.closeModalEvent()
          this.atualizarConsulta()
        })
      } else {
        const dataTable = this.$store.getters.getDataTableChecked
        for (const value of dataTable) {
          const numeroProcesso = value.data.processo
          await this.eliminarProtocolo(numeroProcesso)
        }
      }
    },

    async eliminarProtocolo (numeroProcesso) {
      try {
        this.atualizarProgress(numeroProcesso, {
          porcentagem: '50%',
          status: 'warning'
        })
        const eliminar = {
          ...this.eliminar,
          dataPublicacaoDiario: new Date(this.eliminar.dataPublicacaoDiario).getTime(),
          dataEdital: new Date(this.eliminar.dataEdital).getTime()
        }
        const dadosSessao = this.$store.getters.getDadosSessao.sessao
        await this.service.eliminarProtocolo({
          dadosDiario: eliminar,
          processo: numeroProcesso
        }, dadosSessao)
        this.atualizarProgress(numeroProcesso, {
          porcentagem: '100%',
          status: 'success'
        })
      } catch (error) {
        this.atualizarProgress(numeroProcesso, {
          porcentagem: '100%',
          status: 'danger'
        })
      }
    },

    atualizarProgress (numeroProcesso, obj) {
      this.progress.processos[numeroProcesso] = obj
      this.progress.key = !this.progress.key
    },

    getProgress (numeroProcesso) {
      const processo = this.progress.processos[numeroProcesso]
      return processo ? processo.porcentagem || '0%' : '0%'
    },

    getKey (numeroProcesso) {
      return `${numeroProcesso}-${this.getProgress(numeroProcesso)}`
    },

    getStatus (numeroProcesso) {
      const processo = this.progress.processos[numeroProcesso]
      return processo ? processo.status || 'info' : 'info'
    },

    isVisibleTryAgainEliminar (numeroProcesso) {
      if (!this.progress.isEliminar) {
        return false
      }
      return this.getStatus(numeroProcesso) === 'danger'
    },

    formatarProtocolo (protocolo) {
      return protocoloParse(protocolo).value
    },

    adicionaZero (numero) {
      if (numero <= 9) {
        return '0' + numero
      } else {
        return numero
      }
    }
  }
}
</script>
